import React, { useState, useEffect } from 'react';
import { Flex, Text, Input, Button } from "@aws-amplify/ui-react";
import { getOverrideProps } from "./utils";

const Inventory = ({ data, itemsPerPage = 10, overrides = {} }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setFilteredData(data);
    setLoading(false);
  }, [data]);

  useEffect(() => {
    const filtered = data.filter(
      (item) =>
        item.asin.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.sku.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.availableQuantity.toString().includes(searchQuery)
    );
    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchQuery, data]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, filteredData.length);
  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  if (loading) {
    return <Text>Loading...</Text>;
  }

  return (
    <Flex direction="column" width="100%" maxWidth="100%" backgroundColor="#FAFAFA" {...getOverrideProps(overrides, "Inventory")}>
      <Input
        placeholder="Search..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        width="30%"
        marginBottom="10px"
      />
      <Flex direction="column" width="100%" border="1px SOLID rgba(174,179,183,1)" >
        <Flex direction="row" width="100%" height="65px" alignItems="center" padding="0px 15px" border="1px SOLID rgba(174,179,183,1)">
          <HeaderCell label="ASIN" overrides={overrides} />
          <HeaderCell label="SKU" overrides={overrides} />
          <HeaderCell label="Currently Available Quantity" overrides={overrides} />
        </Flex>
        {currentItems.map((item, index) => (
          <DataRow key={index} item={item} overrides={overrides} />
        ))}
        <Flex direction="row" justifyContent="space-between" alignItems="center" padding="16px">
          <Text>{indexOfFirstItem + 1}-{indexOfLastItem} of {filteredData.length}</Text>
          <Flex gap="10px">
            <Button onClick={handlePrevPage} isDisabled={currentPage === 1} size="small">Previous</Button>
            <Button onClick={handleNextPage} isDisabled={currentPage === totalPages} size="small">Next</Button>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

const HeaderCell = ({ label, overrides }) => (
  <Flex direction="row" justifyContent="center" alignItems="center" flex="1" padding="10px 0px" textAlign="center" {...getOverrideProps(overrides, `Field${label.replace(/\s+/g, '')}`)}>
    <Text fontSize="14px" fontWeight="600" color="rgba(13,26,38,1)" textAlign="center" children={label} {...getOverrideProps(overrides, `label${label.replace(/\s+/g, '')}`)} />
  </Flex>
);

const DataRow = ({ item, overrides }) => (
  <Flex direction="row" justifyContent="center" alignItems="center" width="100%" borderBottom="1px SOLID rgba(239,240,240,1)" padding="10px 15px" {...getOverrideProps(overrides, "ForecastsDataRow")}>
    <DataCell value={item.asin} overrides={overrides} />
    <DataCell value={item.sku} overrides={overrides} />
    <DataCell value={item.availableQuantity} overrides={overrides} />
  </Flex>
);

const DataCell = ({ value, overrides }) => (
  <Flex direction="row" justifyContent="center" alignItems="center" flex="1" padding="10px 0px" textAlign="center" {...getOverrideProps(overrides, `Field${value}`)}>
    <Text fontSize="14px" fontWeight="400" color="rgba(13,26,38,1)" textAlign="center" children={value} {...getOverrideProps(overrides, `label${value}`)} />
  </Flex>
);

export default Inventory;
